import React from 'react';
import IconChevronUp from 'lib/components/Icons/IconChevronUp';
import IconChevronDown from 'lib/components/Icons/IconChevronDown';

export const Toggler = ({ isOpen, size, ...rest }) =>
    isOpen ? <IconChevronUp size={size} {...rest} /> : <IconChevronDown size={size} {...rest} />;
